/**
 * Developer route component — gates the Developer Portal.
 *
 * The `developer` module is a deliberate special case: it is hidden with NO
 * tenant-wide toggle, so access is granted per-user by an admin via
 * `users.developer_portal_enabled`. Tenant admins have implicit access. This
 * guard mirrors the server-side `require_developer_access` gate so a non-granted
 * user typing `/developer` is redirected instead of seeing a broken page.
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth, hasDeveloperPortalAccess } from '../../shared/auth';

interface DeveloperRouteProps {
  children: React.ReactNode;
}

export function DeveloperRoute({ children }: DeveloperRouteProps) {
  const { user } = useAuth();

  if (!hasDeveloperPortalAccess(user)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
